import { gql } from "graphql-tag";
import { useMutation } from "@bb-vendure/admin-ui/react";
import { CUSTOMS_CLEARANCE_BODY } from "./Get-Customs-Clearance";

const REMOVE_CUSTOMS_CLEARANCE_FILES = gql`
  mutation RemoveCustomsClearanceFiles($id: ID!, $assetId: ID!) {
    removeCustomsClearanceFile(id: $id, assetId: $assetId) {
    ${CUSTOMS_CLEARANCE_BODY}
    }
  }
`;

export default function useRemoveCustomClearanceFiles<T>() {
  return useMutation<T>(REMOVE_CUSTOMS_CLEARANCE_FILES);
}
